import ShippingStatusPlugin from '@shipping-status/ShippingStatusPlugin.tsx';
import {memo} from "react";

const ShippingStatusView = () => {
  return <ShippingStatusPlugin />
}

export default memo(ShippingStatusView);